import angular from 'angular';

class ModalUnUpdatePdpRoutingCodeCtrl {

    close() {
        this.modalInstance.dismiss('cancel');
    }
}

angular.module('app.principal').component('modalUnUpdatePdpRoutingCode', {
    templateUrl: require('./modal-unupdated-pdp-routing-code.html'),
    controller: ModalUnUpdatePdpRoutingCodeCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
